function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7656 0.992188L12.5469 0.773438C12.4922 0.71875 12.4193 0.691406 12.3281 0.691406C12.237 0.691406 12.1549 0.71875 12.082 0.773438L6.75 6.13281L1.41797 0.773438C1.34505 0.71875 1.26302 0.691406 1.17188 0.691406C1.08073 0.691406 1.00781 0.71875 0.953125 0.773438L0.734375 0.992188C0.679688 1.04688 0.652344 1.11979 0.652344 1.21094C0.652344 1.30208 0.679688 1.375 0.734375 1.42969L6.53125 7.22656C6.58594 7.28125 6.65885 7.30859 6.75 7.30859C6.84115 7.30859 6.91406 7.28125 6.96875 7.22656L12.7656 1.42969C12.8203 1.375 12.8477 1.30208 12.8477 1.21094C12.8477 1.11979 12.8203 1.04688 12.7656 0.992188Z",
  fill: "currentColor"
});

var SvgChevronDown = function SvgChevronDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-down.29f6711f.svg";
export { ForwardRef as ReactComponent };